<template>
  <div>
    <div class="mt-6 lg:mt-0" :full-width="true">
      <div class="flex flex-wrap -mx-2">
        <div class="w-full px-2">
          <span class="border-r-2 mt-6 mr-6">
             <button @click="tab = 1" class="mt-6 mr-6 text-grey focus:outline-none">
              <h1 slot="header" class="text-xl leading-normal py-4" :class="{'text-grey-darker font-bold': tab === 1}">
                Property Comparison Generator
              </h1>
            </button>
          </span>
          <span class="">
             <button @click="tab = 2" class="mt-6 mr-6 text-grey focus:outline-none">
              <h1 slot="header" class="text-xl leading-normal py-4" :class="{'text-grey-darker font-bold': tab === 2}">
                Generated Reports
              </h1>
            </button>
          </span>
        </div>
      </div>
    </div>
    <div class="mt-2" v-if="tab === 1">
      <property-comparison-page :editReportId="editReportId" />
    </div>
    <div class="mt-2" v-if="tab === 2">
      <property-comparison-previous-report />
    </div>
  </div>
</template>

<script>
import PropertyComparisonPage from '@/views/property/PropertyComparisonPage.vue'
import PropertyComparisonPreviousReport from '@/views/property/PropertyComparisonPreviousReport.vue'

import { mapState } from 'vuex'
export default {
  data () {
    return {
      tab: 1,
      editReportId: 0
    }
  },
  components: {
    PropertyComparisonPage,
    PropertyComparisonPreviousReport
  },
  computed: {
    ...mapState(['selectedOffice'])
  }
}
</script>
